export const experienceData = [
    {
        id: 1,
        company: 'Future Netwings',
        jobtitle: 'AI Intern',
        startYear: '2023',
        endYear: '2023'
    },
    {
        id: 2,
        company: 'Physics Wallah',
        jobtitle: 'Campus Ambassador',
        startYear: '2022',
        endYear: '2024'
    },
]